import React, { useCallback } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getRateOfferModalVisible } from 'logic/store/modal/modal.selectors';
import { modalSlice } from 'logic/store/modal/modal.slice';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { RateOfferForm } from './rate-offer.form';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import './rate.modal.styles.less';

export const RateOfferModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(getRateOfferModalVisible);
  const { minTablet } = useBreakpoints();
  const handleClose = useCallback(() => {
    dispatch(modalSlice.actions.closeGiveRatingModal());
  }, [dispatch]);

  return (
    <Modal
      title={
        <div className="modal-title-container">
          <div className="modal-title">
            <Text color="blueGray" size={minTablet ? 26 : 18} fontWeight={600}>
              {translate(translationKeys.rateTooltips.titleSchool)}
            </Text>
          </div>
        </div>
      }
      visible={visible}
      onCancel={handleClose}
      maskClosable
      footer={null}
      centered
      width={'auto'}
      className={minTablet ? '' : 'modal-fl'}
    >
      <RateOfferForm />
    </Modal>
  );
};
